<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import axios from "@/axios";
import ExportButton from "@/components/export-button";
import { getDateWithFormat, formatCurrency, thousandSeparator } from "@/utils";
import { toExcelThree } from "@/utils";
import DPConfig from "@/components/dataPickerConf";
import Filter from "@/components/filters/Filter";
import moment from "moment";

export default {
  page: {
    title: "Reporte de TAG",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    "export-button": ExportButton,
    filters: Filter,
  },
  data() {
    return {
      sortBy: "fecha",
      sortDesc: true,
      lang: {
        formatLocale: DPConfig.formatLocale,
      },
      valuedp: "",
      placeholderDp: "Rango de fechas",
      currentPage: 1,
      perPage: 10,
      totRegistros: 1,
      fechaDesde: "",
      fechaHasta: "",
      filtros: ["rut", "period", "patent"],
      filtersValue: {
        rutEmpresa: "",
        period: [moment(new Date()).startOf("month").format("YYYY-MM-DD"), new Date()],
        patent: "",
        // tag: true
      },
      isBusy: false,
      inputRUT: "",
      inputPatente: "",
      tableData: [],
      isBusyButtonAll: false,
      fields: [
        {
          key: "patente",
          label: "Patente",
          sortable: false,
        },
        {
          key: "fecha",
          label: "Fecha de ocurrencia",
          sortable: false,
        },
        {
          key: "portico",
          label: "Pórtico",
          sortable: false,
        },
        {
          key: "importe",
          label: "Importe",
          sortable: false,
        },
        {
          key: "asignacion",
          label: "Asignación",
          sortable: false,
        },
        {
          key: "autopista",
          label: "Autopista",
          sortable: false,
        },
        {
          key: "anio",
          label: "Año",
          sortable: false,
        },
        {
          key: "mes",
          label: "Mes",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    getDate(date) {
      return getDateWithFormat(date);
    },
    getCurrency(inport) {
      return formatCurrency(inport);
    },
    getNumberWithSeparators(number) {
      return thousandSeparator(number);
    },
    getTAGReport() {
      if (this.filtersValue.rutEmpresa) {
        this.isBusy = true;
        let data;
        data = {
          rut: this.filtersValue.rutEmpresa ? this.filtersValue.rutEmpresa : "",
          fechaDesde: this.filtersValue.period[0],
          fechaHasta: this.filtersValue.period[1],
          pagina: this.currentPage,
          registros: this.perPage,
          origenFechas: 1,
          idEstadoPago: 0,
        };
        if (this.filtersValue.patent) {
          data.patente = this.filtersValue.patent
        }
        axios
          .post("/GetDetalleTAGVehiculo", data)
          .then((TAGResponse) => {
            this.tableData = TAGResponse.data.datos;
            this.totRegistros = TAGResponse.data.totalRegistros;
            this.isBusy = false;
          })
          .catch((error) => {
            if (error.response) {
              this.$bvToast.toast(this.$t("NoData.error.message").toString(), {
                title: this.$t("NoData.error.title").toString(),
                variant: "danger",
                solid: true,
              });
            }
            this.isBusy = false;
          });
      }
    },
    getAllTAGReport() {
      this.isBusyButtonAll = true;
      let dataAll;
      dataAll = {
        patente: this.filtersValue.patent ? this.filtersValue.patent : "",
        rut: this.filtersValue.rutEmpresa ? this.filtersValue.rutEmpresa : "",
        fechaDesde: this.filtersValue.period[0],
        fechaHasta: this.filtersValue.period[1],
        pagina: 1,
        registros: this.totRegistros,
        origenFechas: 1,
        idEstadoPago: 0,
      };
      axios
        .post("/GetDetalleTAGVehiculo", dataAll)
        .then((TAGResponse) => {
          toExcelThree(TAGResponse.data.datos, "TAG_ALL_");
          this.isBusyButtonAll = false;
        })
        .catch(() => {
          this.$bvToast.toast(this.$t("NoData.error.message").toString(), {
            title: this.$t("NoData.error.title").toString(),
            variant: "danger",
            solid: true,
          });
          this.isBusyButtonAll = false;
        });
    },
    detailView(id, confRoute) {
      this.$store.dispatch("hideValue/updatePatente", id);
      this.$router.push(confRoute);
    },
  },
  watch: {
    currentPage() {
      this.getTAGReport();
    },
  },
  mounted() {
    this.getTAGReport()
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center" class="title d-flex">
              <h4 class="card-tittle custom-title mr-auto">
                TAG
              </h4>
              <export-button
                class="ml-auto"
                :data="tableData"
                fileName="REPORTE_TAG"
                title="Exportar Lista"
              />
              <b-button
                class="spacingButton"
                variant="danger"
                @click="getAllTAGReport()"
              >
                <template v-if="!isBusyButtonAll">Exportar Todo</template>
                <b-spinner v-else small class="align-middle"></b-spinner>
              </b-button>
            </b-row>
            <filters v-model="filtersValue" @change="getTAGReport" patentView="getPatentsTAGByRut"/>
            <!-- Inicio Tabla -->
            <div class="table-responsive mb-0 mt-2">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :current-page="currentPage"
                striped
                hover
                :busy="isBusy"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                show-empty
              >
                <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <!-- Fin Spinner en estado "ocupado" de la tabla -->

                <template #cell(patente)="row">
                  <a
                    class="links"
                    @click="detailView(row.item.patente.trim(), 'documentos')"
                  >
                    {{ row.value }}
                  </a>
                </template>
                <template #cell(fecha)="row">
                  {{ getDate(row.value) }}
                </template>
                <template #cell(importe)="row">
                  {{ "$" + getCurrency(row.value) }}
                </template>

                <template #empty="">
                  <h5 style="text-align: center">
                    {{ $t("request.tag.empty") }}
                  </h5>
                </template>
                <template #cell(mes)="row">
                    {{ $t(`months.${row.value}`) }}
                </template>
              </b-table>
            </div>
            <!-- Fin Tabla -->

            <!-- Inicio Paginación -->
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    class="portal"
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totRegistros"
                  ></b-pagination>
                </ul>
              </div>
            </div>
            <!-- Fin Paginación -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.custom-title {
  margin: 0 !important;
  font-weight: bold;
}
.title {
  padding: 15px;
}
.spacingButton {
  margin-left: 1rem;
}
</style>
